import { Tabs, Tab } from '@mui/material';
import { useState } from 'react';
import TemplateCreator from './TemplateCreator';
import MyTemplates from './MyTemplates';
import { UserConsole } from './UserConsole';
import { Designs } from './Designs';
import ApproveTemplates from './ApproveTemplates';
import { SEO } from './Seo';
import { ReassignTemplates } from './ReassignTemplates';

export function Admin() {
    const [activeTab, setActiveTab] = useState("create");

    const handleChange = (event, newValue) => {
        setActiveTab(newValue);
    };

    return (
        <div>
            <Tabs value={activeTab} onChange={handleChange}>
                <Tab label="Create Template" value="create" />
                <Tab label="Change Template Designer" value="reassign" />
                <Tab label="Approve Templates" value="approve" />
                <Tab label="Users" value="users" />
                <Tab label="Designs" value="designs" />
                <Tab label="SEO" value="seo" />
            </Tabs>
            <div>
                {activeTab === "create" && <div><TemplateCreator /></div>}
                {activeTab === "reassign" && <div><ReassignTemplates /></div>}
                {activeTab === "approve" && <div><ApproveTemplates /></div>}
                {activeTab === "users" && <div><UserConsole /></div>}
                {activeTab === "designs" && <div><Designs/></div>}
                {activeTab === "seo" && <div><SEO/></div>}
            </div>
        </div>
    );
}
